<template>
  <a-modal
    :title="audit ? '还车审批' : '还车详情'"
    class="gufiiguy"
    :visible="is_show"
    style="top: 20px"
    :width="1400"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="is_show = false"
  >
    <template slot="footer">
      <a-button key="back" @click="is_show = false"> 取消 </a-button>
      <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
      <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
      <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
    </template>
    <div ref="sadsada">
      <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <div class="title">
          <span>基本信息</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="审批标题"
                class="model_span_form"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span>{{ mdl.title }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.ccName }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="关联审批单" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span v-for="(item, index) in mdl.associateApply" :key="index" class="auditItem">
                  <span @click="handelAudit(item)">{{ item.associateTitle }}</span>
                </span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="所属公司/部门">
                <span>{{ mdl.companyUseName }}/{{ mdl.deptUseName }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="车辆属性">
                <span>{{ carMap2[mdl.carTypes] }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="牌照号">
                <span>{{ mdl.plateNumber }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="实际用车日期">
                <span>{{ mdl.useCarDate }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="实际还车日期">
                <span>{{ mdl.stillCarDate }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="最近里程(km)">
                <span>{{ mdl.latestMileage }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="出车前里程(km)">
                <span>{{ mdl.goMileage }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="还车时里程(km)">
                <span>{{ mdl.backMileage }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="行驶里程数(km)">
                <span>{{ mdl.travelMileage }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="申请补贴里程(km)">
                <span>{{ mdl.applyMileage }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="项目数">
                <span>{{ mdl.projectNum }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="目的地" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.destination }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span>{{ mdl.remark2 }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="出车前后里程照片" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <div
                  class="view_path_img"
                  v-for="(item, index) in mdl.mileageImgs"
                  :key="index"
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-right: 0;
                    margin-left: 10px;
                    width: calc(10%);
                  "
                >
                  <div class="view_path_img_margin"></div>
                  <div class="view_path_img_center">
                    <img :src="item.imgUrl" @click="show_img(index, mdl.mileageImgs)" />
                  </div>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="出车后车内卫生照片" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <div
                  class="view_path_img"
                  v-for="(item, index) in mdl.hygieneImgs"
                  :key="index"
                  style="
                    display: flex;
                    justify-content: space-between;
                    margin-right: 0;
                    margin-left: 10px;
                    width: calc(10%);
                  "
                >
                  <div class="view_path_img_margin"></div>
                  <div class="view_path_img_center">
                    <img :src="item.imgUrl" @click="show_img(index, mdl.hygieneImgs)" />
                  </div>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="车辆情况">
                <span>{{ carStatus[mdl.vehicleCondition] }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="16">
              <a-form-model-item
                label="车辆备注"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
                v-if="mdl.vehicleCondition == 2"
              >
                <span>{{ mdl.remark }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <div class="title">
          <span>加油详情</span>
        </div>
        <div class="content">
          <a-row v-for="(item, index) in mdl.oils" :key="index">
            <a-col :span="8">
              <a-form-model-item label="加油里程(km)">
                <span>{{ item.fuelMileage }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="加油金额(元)">
                <span>{{ item.fuelMoney }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="本次出行加油金额">
                <span>{{ mdl.money }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="本次出行加油金额大写">
                <span>{{ mdl.capitalizeMoney }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <div class="last_title">
              <div style="font-size: 14px">流程使用说明：</div>
              1、出车前和出车后必须拍照记录当时车辆里程。如果加油，请将加油发票或小票拍照存档（办油卡的拍小票）。<br />
              2、一车一补贴，还车时每辆车需要单独提还车补贴申请<br />
              3、还车时，需要关联用车申请，系统将自动获取车辆明细信息
            </div>
          </a-row>
        </div>
          <div class="title" v-if="!audit && recordNumber==1">
          <span>审批记录</span>
        </div>
        <div class="content" v-if="!audit && recordNumber==1">
          <auditModel ref="auditModel"></auditModel>
        </div>
      </a-form-model>
    </div>
    <!-- 撤销提示 -->
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <preview ref="preview" />
    <business-modal ref="modal" @ok="handleOk" />
    <leave-modal ref="leavemodal" @ok="handleOk" :audit="false" />
    <purchase-modal ref="purchasemodal" @ok="handleOk" :audit="false" />
    <scrap-modal ref="scrapmodal" @ok="handleOk" :audit="false" />
    <receive-modal ref="receiveModal" @ok="handleOk" :audit="false" />
    <operation-modal ref="operationmodal" @ok="handleOk" :audit="false" />
    <service-modal ref="servicemodal" @ok="handleOk" :audit="false" />
    <reimbursement-modal2 ref="reimbursementmodal" @ok="handleOk" :audit="false" />
    <!-- 详情 -->
    <payMentModal2 ref="paymentmodal" :audit="false" />
    <!-- 详情 -->
    <contractModal ref="contractmodal" :audit="false" />
    <transferModal ref="transferModal" @sure="handleSure" />
    <sealModal ref="sealmodal" @ok="handleOk" :audit="false" />
    <currencyModal ref="currencymodal" @ok="handleOk" :audit="false" />
    <returnModal ref="returnmodal" @ok="handleOk" :audit="false" />
    <car-modal ref="carmodal" @ok="handleOk" :audit="false" />
    <returncar-modal2 ref="returncarmodal" @ok="handleOk" :audit="false" />
  </a-modal>
</template>
<script>
import auditModel from './audit.vue'
import { previewFileLists } from '@/utils/preview.js'

import { returnCarApply, auditTask, act_task_audit, reimburse_apply_downlodPdf, modalMap } from '@/api/activiti'
import { getDeptListEnable2 } from '@/api/system'
import preview from '@/components/module/prview'
import BusinessModal from '@/views/activiti/modules/BusinessModal.vue'
import LeaveModal from '@/views/activiti/modules/LeaveModal.vue'
import PurchaseModal from '@/views/activiti/modules/PurchaseModal.vue'
import ScrapModal from '@/views/activiti/modules/ScrapModal.vue'
import receiveModal from '@/views/activiti/modules/receiveModal.vue'
import OperationModal from '@/views/activiti/modules/OperationModal.vue'
import ServiceModal from '@/views/activiti/modules/ServiceModal.vue'
import ReimbursementModal2 from '@/views/activiti/modules/ReimbursementModal2.vue'
import payMentModal2 from '@/views/activiti/modules/payMentModal2.vue'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import sealModal from '@/views/activiti/modules/sealModal.vue'
import currencyModal from '@/views/activiti/modules/currencyModal.vue'
import returnModal from '@/views/activiti/modules/returnModal.vue'
import carModal from '@/views/activiti/modules/carModal.vue'
import returncarModal2 from '@/views/activiti/modules/returncarModal2.vue'
import Watermark from '../../../utils/watermark'
 const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
const deptMap = {}
export default {
  name: 'LeaveModal',
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    BusinessModal,
    LeaveModal,
    PurchaseModal,
    ScrapModal,
    receiveModal,
    OperationModal,
    ServiceModal,
    ReimbursementModal2,
    payMentModal2,
    contractModal,
    transferModal,
    sealModal,
    currencyModal,
    returnModal,
    carModal,
    returncarModal2,
    auditModel
  },
  data() {
    return {
      recordNumber: 0,
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      deptTree: [],
      deptMap,
      visible: false,
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      confirmLoading: false,
      mdl: {},
      options: [],
      dateFormat: 'YYYY-MM-DD HH:mm',
      formData: {},
      form: this.$form.createForm(this),
      is_show: false,
      record: '',
    }
  },
  created() {
    getDeptListEnable2().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, min)
        this.deptTree.map((d) => {
          if (d.hasOwnProperty('children')) {
            d.children.map((b) => {
              deptMap[b.key] = {
                text: b.title,
              }
              deptMap[d.key] = {
                text: d.title,
              }
            })
          } else {
            deptMap[d.key] = {
              text: d.title,
            }
          }
        })
        this.expandedKeys = data.map((m) => m.parentId)
        this.dataList = data.map((m) => {
          return {
            key: m.deptId,
            title: m.deptName,
          }
        })
      }
    })
  },
  methods: {
    handelAudit(item) {
      const modal = modalMap[item.associateTypes]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: item.associateApply,
      })
    },
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    },
    handelAudit(item) {
      const modal = modalMap[item.associateTypes]
      console.log(modal)
      this.$refs[modal].show({
        businessKey: item.associateApply,
      })
    },
    download() {
      reimburse_apply_downlodPdf({
        businessKey: this.record.businessKey,
      }).then((res) => {
        window.open(exportBaseUrl + '/file/download?path=' + res.data)
      })
    },
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      this.$refs.preview.show(row)
    },
    //预览文件
    previewFile(file) {
      console.log(file)
      window.open(file.preUrl)
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    show(record) {
      this.recordNumber = record.recordNumber
      this.record = record
      // record 是任务 如果只是查看可以只传入一个businessKey
      if (this.audit) {
        this.formData = Object.assign({
          taskId: record.id,
          procInstId: record.procInstId,
          procName: record.processDefName,
          businessKey: record.businessKey,
          procDefKey: record.processDefKey,
          applyer: record.applyer,
        })
      }
      returnCarApply(record.businessKey).then((res) => {
        if (res.code === 200) {
          const { type } = res.data
          this.mdl = Object.assign(res.data)
          previewFileLists(this.mdl.mileageImgs).then((res) => {
            this.mdl.mileageImgs = res
          })
		   previewFileLists(this.mdl.hygieneImgs).then((res) => {
            this.mdl.hygieneImgs = res
          })
          this.is_show = true
          this.$nextTick(() => {
            Watermark.set('安联云管家', this.$refs.sadsada)
             if(!this.audit && this.recordNumber==1) {
                 this.$refs.auditModel.show(record)
               }
          })
        }
      })
    },
    handleSubmit(result) {
      this.confirmLoading = true
      const formData = this.formData
      formData.result = result
      auditTask(formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.$emit('ok')
            this.is_show = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
        console.log(this.record.procName)
      }
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
          this.actTask()
        }
      } else if (this.result == 2) {
        this.actTask()
      }
    },
    actTask() {
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: this.result,
        businessKey: this.record.businessKey,
        comment: this.comment,
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.is_show = false
        this.is_revocation = false
      })
    },
  },
  watch: {
    /*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-input-disabled {
  color: #000;
  background-color: #fff;
}

/deep/ .ant-select-disabled {
  color: #000;
}

/deep/ .ant-select-selection {
  background-color: #fff;
}

.view_path {
  width: 100%;
  float: left;
  cursor: pointer;
}

.auditItem {
  border-radius: 5px;
  background-color: #f8f8f8;
  // margin-left: 10px;
  color: dodgerblue;
  padding: 0;
}

.last_title {
  padding: 20px;
  margin: 20px 20px 0px 20px;
  background-color: #f8f8f7;
  color: #b6b6b6;
}
</style>
